import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input, Select, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { useCategories } from "../../categories/hooks";
import { CmsSelectSearch } from "../../cms/components";
import { CustomerStatus, FindBySource } from "../../../__generated__/globalTypes";
import { customerStatusLabel, findBySourceLabel } from "../../../helpers/enum-labels";

interface ICustomerForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const CustomerForm: React.FC<ICustomerForm> = ({
  loading,
  form,
  submit,
}) => {
  const { data } = useCategories();

  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Input
          label="Nom"
          className="w-full"
          {...form.register("name", { required: "Nom requis" })}
          placeholder="Nom du client"
        />
        <Input
          label="Email"
          className="w-full"
          {...form.register("email")}
          placeholder="contact@client.fr"
        />
        <Input
          label="Téléphone"
          className="w-full"
          {...form.register("phone")}
          placeholder="+33..."
        />
        <Input
          label="Site"
          className="w-full"
          {...form.register("site")}
          placeholder="https://client.fr"
        />
        <Input
          label="Adresse"
          className="w-full"
          {...form.register("address")}
          placeholder="12 rue de la République"
        />
        <Input
          label="Code postal"
          className="w-full"
          {...form.register("postalCode")}
          placeholder="06000"
        />
        <Input
          label="Ville"
          className="w-full"
          {...form.register("city")}
          placeholder="Nice"
        />
        <Select label="Statut" className="w-full" {...form.register("status", { required: true })}>
          {Object.keys(CustomerStatus).map((key) => (
            <option key={key} value={key}>
              {customerStatusLabel(key)}
            </option>
          ))}
        </Select>
        <Select label="Trouvé via" className="w-full" {...form.register("findBy")}>
          <option value="">-</option>
          {Object.keys(FindBySource).map((key) => (
            <option key={key} value={key}>
              {findBySourceLabel(key)}
            </option>
          ))}
        </Select>
        <Select label="Catégorie" className="w-full" {...form.register("categoryId")}>
          <option value="">-</option>
          {data?.categories?.results?.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </Select>
        <CmsSelectSearch form={form} />
        <Textarea
          label="Notes"
          className="w-full"
          {...form.register("note")}
          placeholder="Contexte, historique d'échanges, informations sur le client..."
        />
        <Textarea
          label="À faire"
          className="w-full"
          {...form.register("todo")}
          placeholder="Ce qu'il reste à faire pour ce client..."
        />
        <label className="w-full flex items-center gap-2">
          <input type="checkbox" {...form.register("analyseDone")} />
          <span className="text-sm">Analyse effectuée</span>
        </label>
        <label className="w-full flex items-center gap-2">
          <input type="checkbox" {...form.register("problemsDetected")} />
          <span className="text-sm">Problèmes détectés</span>
        </label>
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
